































import { Vue, Component, Prop } from 'vue-property-decorator';
import Container from '@/components/Registration/v2/Container.vue';
import RegistrationCard from '@/components/Registration/v2/Card.vue';
import CardHeader from '@/components/Registration/v2/Header.vue';
import { vxm } from '@/store.vuex';

@Component({
  name: 'OTPLoginSuccess',
  components: {
    Container,
    RegistrationCard,
    CardHeader,
  },
})
export default class OTPLoginSuccess extends Vue {
  $wlToastr: any;

  get getTitle() {
    return this.$t('otp-login-success.title');
  }

  async continueToAccount() {
    // Complete user login (redirect to home remove otp token)
    await vxm.users.completeOtpLogin();
  }

  resetPassword() {
    this.$router.push({ name: 'ChangePasswordV2' });
  }
}
